import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { ENUM_UTILS__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { useMemo } from 'react';
import { use_slice_user } from '../../../../hooks/store/use_slices';

export function HOOK_GRID2D_CELL__size(entity: DTO__entity_with_grid2d) {
  const { user_settings } = use_slice_user(['user_settings']);

  /*
   * STATE
   */

  const aspect_ratio_cell = useMemo(() => get_aspect_ratio_cell(), [entity]);

  const max_side = useMemo(() => ENUM_UTILS__grid2d_cell_size.size_to_max_side(user_settings.ui_grid2d_cell_size), [user_settings.ui_grid2d_cell_size]);

  const cell_width = useMemo(() => {
    if (entity.type !== ENUM__workspace_entity.ENTITY_GENERATION) return max_side;
    if (entity.is_stub()) return max_side;

    return aspect_ratio_cell > 1 ? max_side : Math.round(max_side * aspect_ratio_cell);
  }, [entity, max_side, aspect_ratio_cell]);

  const cell_height = useMemo(() => {
    if (entity.type !== ENUM__workspace_entity.ENTITY_GENERATION) return max_side;
    if (entity.is_stub()) return max_side;

    return aspect_ratio_cell > 1 ? Math.round(max_side / aspect_ratio_cell) : max_side;
  }, [entity, max_side, aspect_ratio_cell]);

  /*
   * METHODS
   */

  function get_aspect_ratio_cell() {
    if (entity.type !== ENUM__workspace_entity.ENTITY_GENERATION) return 0;
    if (entity.is_stub()) return 0;

    assert_instanceof(entity, DTO__generation);

    const out = entity.tool.graph.invocation_grid2d_view.grid2d_cell__aspect_ratio;

    return out;
  }

  return { cell_width, cell_height };
}
